export function auditsForPublishedSchedules(group) {
    return group?.some((c) => c.shortDescription.toLowerCase().includes("published"))
}
